import React, { useEffect, useRef, useState } from 'react';
import Header from '../../directives/header';
import Footer from '../../directives/footer';
import Sidebar from '../../directives/sidebar';
import toast, { Toaster } from 'react-hot-toast';
import JoditEditor from 'jodit-react';
import { getAllCms, updateCms } from "../../Action/action";

const AmlKycPolicy = () => {
  const editor = useRef(null);

  const [amlKycPolicyId, setAmlKycPolicyId] = useState(null);
  const [amlKycPolicyContent, setAmlKycPolicyContent] = useState('');

  useEffect(() => {
	getCmsDetail();
  }, []);

  const getCmsDetail = async () => {
	try {
	  const res = await getAllCms();
	  if (res.status) {
		setAmlKycPolicyId(res.data._id);
		setAmlKycPolicyContent(res.data.amlKycPolicy);
	  }
	} catch (err) {
	  toast.error("Failed to fetch AML/KYC Policy");
	}
  };

  const handleUpdate = async () => {
	if (!amlKycPolicyId) {
	  toast.error("AML/KYC Policy ID missing");
	  return;
	}

	try {
	  const res = await updateCms({
		_id: amlKycPolicyId,
		amlKycPolicy: amlKycPolicyContent,
		amlKycPolicyUpdatedAt:new Date()
	  });

	  if (res.status) {
		toast.success('AML/KYC Policy updated successfully!');
		getCmsDetail(); // refresh data
	  }
	} catch (error) {
	  toast.error(error.message || "Failed to update AML/KYC Policy");
	}
  };

  return (
	<div className="wrapper h-auto">
	  <Header />
	  <Toaster />
	  <Sidebar />

	  <div className="content-wrapper">
		<div className="container-full">
		  <section className="content">
			<div className="row">
			  <div className="col-lg-12 col-12 p-4">
				<div className="box">
				  <div className="box-header with-border">
					<h3 className="box-title" style={{ fontWeight: 600 }}>
					  AML/KYC Policy
					</h3>
				  </div>

				  <div className="row mt-20 mb-50">
					<div className="col-md-12">
					  <div className="form-group row mb-3 px-15">
						<label className="col-form-label">
						  AML/KYC Policy Content
						</label>

						<JoditEditor
						  ref={editor}
						  value={amlKycPolicyContent}
						  tabIndex={1}
						  onBlur={(newContent) =>
							setAmlKycPolicyContent(newContent)
						  }
						/>
					  </div>

					  <div className="text-start px-15">
						<button
						  type="button"
						  className="btn btn-primary"
						  onClick={handleUpdate}
						>
						  Update
						</button>
					  </div>

					</div>
				  </div>

				</div>
			  </div>
			</div>
		  </section>
		</div>
	  </div>

	  <Footer />
	</div>
  );
};

export default AmlKycPolicy;
